var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceSettingsTiltHigh = function SvgDeviceSettingsTiltHigh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3803",
    width: 41,
    height: 28,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1024.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3822",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.105,
    d: "M-6.071 2.688a2.634 2.723 0 1 1-5.268 0 2.634 2.723 0 1 1 5.268 0z",
    transform: "matrix(1.1959 0 0 1.1567 20.65 1028.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4332",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.105,
    d: "M-6.071 2.688a2.634 2.723 0 1 1-5.268 0 2.634 2.723 0 1 1 5.268 0z",
    transform: "matrix(1.1959 0 0 1.1567 43.15 1036.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4334",
    fill: "currentColor",
    d: "M5.645 1028.4c-.172-.01-.346.011-.531.031a2.5 2.5 0 0 0-.719.188c-.894.386-2.7 2.895-2.656 4.375s-.523 1.273 1 3.53c1.523 2.259 6.87 6.502 10.28 8.25 3.411 1.75 6.549 2.562 10.407 2.563 3.859 0 11.906-.937 11.906-.937s1.755.167 3.406-2.125-.687-3.969-.687-3.969l-.844-.312c-.101 2.395-2.048 4.312-4.469 4.312a4.5 4.5 0 0 1-4.5-4.5 4.5 4.5 0 0 1 1-2.812l-14.531-5.438c.005.085.031.164.031.25a4.5 4.5 0 1 1-9 0c0-1.21.473-2.316 1.25-3.125l-.406-.156s-.42-.11-.937-.125zm1.813 9.625 22.187 7.344s-3.951.967-7.276.89c-3.6-.035-9.628-2.17-13.412-5.796-2.214-2.069-1.5-2.438-1.5-2.438z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4336",
    fill: "currentColor",
    d: "M2.239 1047.3h36v1.5h-36z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceSettingsTiltHigh);
export default ForwardRef;